import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Plot from "react-plotly.js";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Projectcolors from "../Utils/Colors";
import { ListItemAvatar, Typography } from "@mui/material";
import LinePlotRaw from "./LinePlotRaw";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import { Checkbox } from "@mui/material";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import axios from "axios";

const menuprops = {
  PaperProps: {
    style: {
      maxHeight: 250,
    },
  },
};

function ScatterPlotMethod(props) {
  const [rawdata, setRawData] = React.useState([]);

  const [lineplotdata, setLineplotdata] = React.useState([]);

  const [lineplotx, setLineplotx] = React.useState([]);
  const [x, setX] = React.useState("");
  const [y, setY] = React.useState("");
  const [ylabel, setYLabel] = React.useState("Y axis");
  const [xlabelscatter, setXscatter] = React.useState();
  const [ylabelscatter, setYscatter] = React.useState();
  const [alltagname, setTagname] = React.useState([]);
  const [getLoader, setGetLoader] = React.useState(false);
  const [timeseries, setTimeseries] = React.useState(1);
  const [alllinear_ys, setalllinear_ys] = React.useState([]);
  const [linear_ab, setlinear_ab] = React.useState([]);
  const [allexp_ys, setallexp_ys] = React.useState([]);
  const [exp_ab, setexp_ab] = React.useState([]);
  const [alllogsy, setalllogsy] = React.useState([]);
  const [logsab, setlogsab] = React.useState([]);
  const [linear, setlinear] = React.useState(false);
  const [exp, setexp] = React.useState(false);
  const [log, setlog] = React.useState(false);
  const [quad, setquad] = React.useState(false);
  const [hyper, sethyper] = React.useState(false);
  const [linearequation, setlinearequation] = React.useState("");
  const [expequation, setexpequation] = React.useState("");
  const [logarithmicequation, setlogarithmicequation] = React.useState("");
  const [hyperequation, sethyperequation] = React.useState("");
  const [quadraticequation, setquadraticequation] = React.useState("");

  const [allhyperbolic, setallhyperbolic] = React.useState([]);
  const [hyperbolicab, sethyperbolicab] = React.useState([]);
  const [allquadratic, setallquadratic] = React.useState([]);
  const [quadab, setquadab] = React.useState([]);

  const [checkedState, setCheckedState] = React.useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [plotlydata, setplotlydata] = React.useState([
    {
      x: lineplotdata[x],
      y: lineplotdata[y],
      type: "scatter",
      mode: "markers",
      marker: { color: Projectcolors.primary },
      name: "Real Data",
    },
  ]);

  const handledropdownx = (e) => {
    
    setX(e.target.value);
    var xlabel = rawdata[e.target.value][1].length > 35? rawdata[e.target.value][1].substring(0, 25) + "...": rawdata[e.target.value][1]
    setXscatter(xlabel);
    if (plotlydata.length === 1) {
      const myFirstList = [...plotlydata];
      const artwork = myFirstList.find((a) => a.name === "Real Data");
      artwork.x = lineplotdata[e.target.value];
      artwork.y = lineplotdata[y];
      setplotlydata(myFirstList);
    }
    if (plotlydata.length > 1) {
      const myFirstList = [...plotlydata];
      const artwork = myFirstList.find((a) => a.name === "Real Data");
      artwork.x = lineplotdata[e.target.value];
      artwork.y = lineplotdata[y];
      setplotlydata(myFirstList);
      if (linear) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Linear");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = alllinear_ys[e.target.value][y];
        setplotlydata(mysecondList);
        setlinearequation(linear_ab[e.target.value][y]);
      }
      if (exp) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Exponential");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = allexp_ys[e.target.value][y];
        setplotlydata(mysecondList);
        setexpequation(exp_ab[e.target.value][y]);
      }
      if (log) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Logarithmic");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = alllogsy[e.target.value][y];
        setplotlydata(mysecondList);
        setlogarithmicequation(logsab[e.target.value][y]);
      }
      if (hyper) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Hyperbolic");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = allhyperbolic[e.target.value][y];
        setplotlydata(mysecondList);
        sethyperequation(hyperbolicab[e.target.value][y]);
      }
      if (quad) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Quadratic");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = allquadratic[e.target.value][y];
        setplotlydata(mysecondList);
        setquadraticequation(quadab[e.target.value][y]);
      }
    }
  };
  const handledropdowny = (e) => {
    setY(e.target.value);
    var ylabel = rawdata[e.target.value][1].length > 35? rawdata[e.target.value][1].substring(0, 25) + "...": rawdata[e.target.value][1]
    setYscatter(ylabel);
    if (plotlydata.length === 1) {
      const myFirstList = [...plotlydata];
      const artwork = myFirstList.find((a) => a.name === "Real Data");
      artwork.x = lineplotdata[x];
      artwork.y = lineplotdata[e.target.value];
      setplotlydata(myFirstList);
    } else if (plotlydata.length > 1) {
      const myFirstList = [...plotlydata];
      const artwork = myFirstList.find((a) => a.name === "Real Data");
      artwork.x = lineplotdata[x];
      artwork.y = lineplotdata[e.target.value];
      setplotlydata(myFirstList);
      if (linear) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Linear");
        artwork.x = lineplotdata[x];
        artwork.y = alllinear_ys[x][e.target.value];
        setplotlydata(mysecondList);
        setlinearequation(linear_ab[x][e.target.value]);
      }
      if (exp) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Exponential");
        artwork.x = lineplotdata[x];
        artwork.y = allexp_ys[x][e.target.value];
        setplotlydata(mysecondList);
        setexpequation(exp_ab[x][e.target.value]);
      }
      if (log) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Logarithmic");
        artwork.x = lineplotdata[x];
        artwork.y = alllogsy[x][e.target.value];
        setplotlydata(mysecondList);
        setlogarithmicequation(logsab[x][e.target.value]);
      }
      if (hyper) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Hyperbolic");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = allhyperbolic[x][e.target.value];
        setplotlydata(mysecondList);
        sethyperequation(hyperbolicab[x][e.target.value]);
      }
      if (quad) {
        const mysecondList = [...plotlydata];
        const artwork = mysecondList.find((a) => a.name === "Quadratic");
        artwork.x = lineplotdata[e.target.value];
        artwork.y = allquadratic[x][e.target.value];
        setplotlydata(mysecondList);
        setquadraticequation(quadab[x][e.target.value]);
      }
    }
  };

  useEffect(() => {
    getRawData();
  }, []);

  const getRawData = () => {
    setGetLoader(true);

    const ProjectID = sessionStorage.getItem("projectID");
    axios.get(
      `${baseURL}/getscatterplotdata?projectID=${ProjectID}&scatterplot=${1}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.data.code === 0){
          setGetLoader(false);
          console.log(res.data);
        }
        else{
        if (res.data.timeseries === 1) {
          setTimeseries(1);
        } else {
          setTimeseries(res.data.timeseries);
          setRawData(res.data.raw_data);
          setalllinear_ys(res.data.alllinear_ys);
          setlinear_ab(res.data.linear_ab);
          setLineplotdata(res.data.lineplotdata);
          setLineplotx(res.data.lineplotdata[0]);
          setTagname(res.data.tag_name);
          setX(0);
          setY(1);
          setXscatter(alltagname[0]);
          setYscatter(alltagname[1]);
          setGetLoader(false);
          setallexp_ys(res.data.allexp_ys);
          setexp_ab(res.data.exp_ab);
          setalllogsy(res.data.alllogsy);
          setlogsab(res.data.logsab);
          setallhyperbolic(res.data.allhyperbolic);
          sethyperbolicab(res.data.hyperbolicab);
          setallquadratic(res.data.allquadratic);
          setquadab(res.data.quadab);
        }
      }
        
      
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };

  const NextStep = () => {
    props.handleNextStep();
  };
  const handleSelect = () => {
    if (xlabelscatter) {
      return <span style={{ color: "black" }}>{xlabelscatter}</span>;
    }
    return <span style={{ color: "#888888" }}>Select</span>;
  };

  const handleSelectY = () => {
    if (ylabelscatter) {
      return <span style={{ color: "black" }}>{ylabelscatter}</span>;
    }
    return <span style={{ color: "#888888" }}>Select</span>;
  };

  const handleOnChange = (value, check) => {
    //setchoosen(value)
    if (plotlydata.length === 1) {
      const myFirstList = [...plotlydata];
      const artwork = myFirstList.find((a) => a.name === "Real Data");
      artwork.x = lineplotdata[x];
      artwork.y = lineplotdata[y];
      setplotlydata(myFirstList);
    }
    if (value === 0) {
      if (check === false) {
        const checkedprev = [...checkedState];
        checkedprev[0] = true; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setlinear(true);

        const updateUsers = [
          ...plotlydata,
          {
            x: lineplotdata[x],
            y: alllinear_ys[x][y],
            type: "line",
            mode: "lines+text",
            marker: { color: "red" },
            name: "Linear",
            line: {
              dash: "dot",
            },
          },
        ];
        setplotlydata(updateUsers);
        setlinearequation(linear_ab[x][y]);
      } else {
        const checkedprev = [...checkedState];
        checkedprev[0] = false; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setlinear(false);

        setplotlydata(plotlydata.filter((a) => a.name !== "Linear"));
        setlinearequation("");
      }
    }

    if (value === 1) {
      if (check === false) {
        const checkedprev = [...checkedState];
        checkedprev[1] = true; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setexp(true);

        const updateUsers = [
          ...plotlydata,
          {
            x: lineplotdata[x],
            y: allexp_ys[x][y],
            type: "line",
            mode: "lines",
            marker: { color: "green" },
            name: "Exponential",
            line: {
              dash: "dot",
            },
          },
        ];
        setplotlydata(updateUsers);
        setexpequation(exp_ab[x][y]);
      } else {
        const checkedprev = [...checkedState];
        checkedprev[1] = false; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setexp(false);
        setplotlydata(plotlydata.filter((a) => a.name !== "Exponential"));
        setexpequation("");
      }
    }

    if (value === 2) {
      if (check === false) {
        const checkedprev = [...checkedState];
        checkedprev[2] = true; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setlog(true);

        const updateUsers = [
          ...plotlydata,
          {
            x: lineplotdata[x],
            y: alllogsy[x][y],
            type: "line",
            mode: "lines",
            marker: { color: "yellow" },
            name: "Logarithmic",
            line: {
              dash: "dot",
            },
          },
        ];
        setplotlydata(updateUsers);
        setlogarithmicequation(logsab[x][y]);
      } else {
        const checkedprev = [...checkedState];
        checkedprev[2] = false; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setlog(false);
        setplotlydata(plotlydata.filter((a) => a.name !== "Logarithmic"));
        setlogarithmicequation("");
      }
    }

    if (value === 3) {
      if (check === false) {
        const checkedprev = [...checkedState];
        checkedprev[3] = true; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        sethyper(true);

        const updateUsers = [
          ...plotlydata,
          {
            x: lineplotdata[x],
            y: allhyperbolic[x][y],
            type: "line",
            mode: "lines",
            marker: { color: "lightblue" },
            name: "Hyperbolic",
            line: {
              dash: "dot",
            },
          },
        ];
        setplotlydata(updateUsers);
        sethyperequation(hyperbolicab[x][y]);
      } else {
        const checkedprev = [...checkedState];
        checkedprev[3] = false; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        sethyper(false);
        setplotlydata(plotlydata.filter((a) => a.name !== "Hyperbolic"));
        sethyperequation("");
      }
    }

    if (value === 4) {
      if (check === false) {
        const checkedprev = [...checkedState];
        checkedprev[4] = true; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setquad(true);

        const updateUsers = [
          ...plotlydata,
          {
            x: lineplotdata[x],
            y: allquadratic[x][y],
            type: "line",
            mode: "lines",
            marker: { color: "orange" },
            name: "Quadratic",
            line: {
              dash: "dot",
            },
          },
        ];
        setplotlydata(updateUsers);
        setquadraticequation(quadab[x][y]);
      } else {
        const checkedprev = [...checkedState];
        checkedprev[4] = false; // Problem: mutates list[0]
        setCheckedState(checkedprev);
        setquad(false);
        setplotlydata(plotlydata.filter((a) => a.name !== "Quadratic"));
        setquadraticequation("");
      }
    }
    
   
  };

  return (
    <div>
      {timeseries ? (
        <div>
           <Box
        component={Paper}
        elevation={3}
        sx={{
          height: "575px",
          p: "24px",
          m: "10px 0",
          borderRadius: "22px",
          border: "2px solid #0078c9",
          boxShadow: "0 8px 25px rgba(0,120,201,.08)",
          background:
            "linear-gradient(to bottom,#ffffff,#fbfcff)",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: Projectcolors.primary,
            textAlign: "center",
            mt: 25,
            fontWeight: 600,
          }}
        >
          Data Includes Time Series. Try Forecasting Algorithms.
        </Typography>
      </Box>
        </div>
      ) : (
        <div>
          <Box
  component={Paper}
  elevation={0}
  sx={{
    height: "740px",
    p: "24px",
    m: "2px 0",
    borderRadius: "22px",
    border: "2px solid #0078c9",
    background:
      "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow: "0 8px 25px rgba(0,120,201,.08)",
  }}
>
  <Box
    sx={{
      display: "flex",
      gap: 3,
      alignItems: "stretch",
    }}
  >

    {/* GRAPH CARD */}
    <Paper
      elevation={6}
      sx={{
        flex: 1,
        borderRadius: "22px",
        p: 2,
        border: "1px solid #d9e9f7",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            color: "#0078c9",
          }}
        >
          Visualization Plot
        </Typography>
      </Box>

      {plotlydata.length > 1 ? (
        <Plot
          data={plotlydata}
          layout={{
            width: 820,
            height: 340,
            margin: { t: 30, b: 60 },

            paper_bgcolor: "white",
            plot_bgcolor: "white",

            xaxis: {
              title: xlabelscatter,
              gridcolor: "#edf2f7",
            },

            yaxis: {
              title: ylabelscatter,
              gridcolor: "#edf2f7",
            },
          }}
          config={{
            displaylogo: false,
          }}
        />
      ) : (
        <Plot
          data={[
            {
              x: lineplotdata[x],
              y: lineplotdata[y],
              type: "scatter",
              mode: "markers",
              marker: {
                color: "#0078c9",
              },
              name: "Real Data",
            },
          ]}
          layout={{
            width: 820,
            height: 340,
            margin: { t: 30, b: 60 },

            paper_bgcolor: "white",
            plot_bgcolor: "white",

            xaxis: {
              title: xlabelscatter,
              gridcolor: "#edf2f7",
            },

            yaxis: {
              title: ylabelscatter,
              gridcolor: "#edf2f7",
            },
          }}
          config={{
            displaylogo: false,
          }}
        />
      )}

      {/* EQUATIONS */}
      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: "16px",
          bgcolor: "#f8fbff",
        }}
      >
        {linear && (
          <Typography
            sx={{
              fontSize: 12,
              mb: 1,
              fontWeight: 600,
            }}
          >
            Linear: {linearequation}
          </Typography>
        )}

        {exp && (
          <Typography
            sx={{
              fontSize: 12,
              mb: 1,
              fontWeight: 600,
            }}
          >
            Exponential: {expequation}
          </Typography>
        )}

        {log && (
          <Typography
            sx={{
              fontSize: 12,
              mb: 1,
              fontWeight: 600,
            }}
          >
            Logarithmic: {logarithmicequation}
          </Typography>
        )}

        {hyper && (
          <Typography
            sx={{
              fontSize: 12,
              mb: 1,
              fontWeight: 600,
            }}
          >
            Hyperbolic: {hyperequation}
          </Typography>
        )}

        {quad && (
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Quadratic: {quadraticequation}
          </Typography>
        )}
      </Box>
    </Paper>

    {/* CONTROL PANEL */}
    <Paper
      elevation={6}
      sx={{
        width: 280,
        borderRadius: "22px",
        p: 3,
        border: "1px solid #d9e9f7",
      }}
    >
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: "#0078c9",
          mb: 3,
        }}
      >
        Plot Controls
      </Typography>

      <Typography
        sx={{
          fontSize: 12,
          mb: .5,
          fontWeight: 500,
        }}
      >
        X Axis
      </Typography>

      <FormControl fullWidth size="small">
        <Select
          onChange={handledropdownx}
          renderValue={handleSelect}
          MenuProps={menuprops}
          sx={{
            borderRadius: "12px",

            "& .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#0078c9",
            },
          }}
        >
          {rawdata?.map((item,i)=>(
            <MenuItem
              key={i}
              value={i}
              sx={{fontSize:12}}
            >
              {item[1]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography
        sx={{
          fontSize:12,
          mt:3,
          mb:.5,
          fontWeight:500
        }}
      >
        Y Axis
      </Typography>

      <FormControl fullWidth size="small">
        <Select
          onChange={handledropdowny}
          renderValue={handleSelectY}
          MenuProps={menuprops}
          sx={{
            borderRadius:"12px",

            "& .MuiOutlinedInput-notchedOutline":
            {
              borderColor:"#0078c9"
            }
          }}
        >
          {rawdata?.map((item,i)=>(
            <MenuItem
              key={i}
              value={i}
              sx={{fontSize:12}}
            >
              {item[1]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* CHECKBOXES */}

      <Box mt={3}>
        {[
          "Linear",
          "Exponential",
          "Logarithmic",
          "Hyperbolic",
          "Quadratic",
        ].map((item,index)=>(
          <Box
            key={index}
            sx={{
              display:"flex",
              alignItems:"center",
              mb:1
            }}
          >
            <Checkbox
              checked={checkedState[index]}
              onChange={()=>handleOnChange(index,checkedState[index])}
              sx={{
                color:"#0078c9",

                "&.Mui-checked":{
                  color:"#9e0b22"
                }
              }}
            />

            <Typography
              sx={{fontSize:12}}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>

      <Button
        onClick={NextStep}
        variant="contained"
        fullWidth
        sx={{
          mt:3,
          height:"42px",
          borderRadius:"12px",
          background:"#0078c9",

          "&:hover":{
            background:"#9e0b22"
          }
        }}
      >
        Next
        <ChevronRightIcon />
      </Button>

    </Paper>

  </Box>
</Box>
        </div>
      )}
    </div>
  );
}

export default ScatterPlotMethod;
